import type { CommonBullJobResponseDto } from 'app/API';

export const MEDIA_ANALYSIS_MAX_CHECKS = 60;

export type TMediaAnalysisOutcome = { status: 'pending' } | { status: 'done'; duration: number } | { status: 'error' };

export const resolveMediaAnalysisOutcome = (
  response: Partial<CommonBullJobResponseDto> | undefined,
  checksCount: number,
): TMediaAnalysisOutcome => {
  if (response?.returnvalue) {
    const duration = Number(response.returnvalue.duration) || 0;
    return duration ? { status: 'done', duration } : { status: 'error' };
  }
  if (response?.failedReason || checksCount >= MEDIA_ANALYSIS_MAX_CHECKS) {
    return { status: 'error' };
  }
  return { status: 'pending' };
};
